import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Table, Card as BsCard, Button } from 'react-bootstrap'
import Card from '../../../components/Card'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { BASE_URL } from '../../../constants/Endpoints'
import axios from 'axios'
import ServiceDetailsModal from './ServiceDetailsModal'
import PaginationComponent from '../../../components/partials/backend/Pagination/PaginationComponent'
import { PrivacyService } from '../../../service/privacy-service'
import { InviaAffidaService } from '../../../service/invia-affida-service'

const ContactServiceHistory = () => {
    const { id } = useParams()
    const history = useHistory()
    const { config } = useSelector((state) => state.auth)
    const [contact, setContact] = useState(null)
    
    const servicesHidden = config?.is_agent && config?.services_allowed === false;
    
    // Service States
    const [censimenti, setCensimenti] = useState({ data: [], pagination: null, loading: false })
    const [quote, setQuote] = useState({ data: [], pagination: null, loading: false })
    const [criteri, setCriteri] = useState({ data: [], pagination: null, loading: false })
    const [preventivi, setPreventivi] = useState({ data: [], pagination: null, loading: false })
    const [privacies, setPrivacies] = useState({ data: [], pagination: null, loading: false })
    const [inviaAffida, setInviaAffida] = useState({ data: [], pagination: null, loading: false })

    // Modal State
    const [showModal, setShowModal] = useState(false)
    const [modalType, setModalType] = useState('')
    const [selectedItem, setSelectedItem] = useState(null)

    useEffect(() => {
        const getContact = async () => {
            try {
                const contactRes = await axios.get(`${BASE_URL}/api-v1/people/contact/${id}/view`, { withCredentials: true })
                setContact(contactRes.data)
            } catch (error) {
                console.error("Error fetching contact", error)
            }
        }
        getContact()
        
        fetchService('censimento', setCensimenti)
        fetchService('quota', setQuote)
        fetchService('criteri', setCriteri)
        fetchService('preventivi', setPreventivi)
        fetchPrivacies()
        fetchInviaAffida()
    }, [id])

    const fetchPrivacies = async () => {
        setPrivacies(prev => ({ ...prev, loading: true }))
        try {
            const privacyService = new PrivacyService()
            const res = await privacyService.listForContact(id)
            setPrivacies({
                data: Array.isArray(res) ? res : (res.data || []),
                pagination: null,
                loading: false,
            })
        } catch (error) {
            console.error('Error fetching privacies', error)
            setPrivacies(prev => ({ ...prev, loading: false }))
        }
    }

    const fetchInviaAffida = async () => {
        setInviaAffida(prev => ({ ...prev, loading: true }))
        try {
            const affidaService = new InviaAffidaService()
            const res = await affidaService.listForContact(id)
            const payload = res && res.data ? res : { data: Array.isArray(res) ? res : [], pagination: null }
            setInviaAffida({
                data: Array.isArray(payload.data) ? payload.data : [],
                pagination: payload.pagination || null,
                loading: false,
            })
        } catch (error) {
            console.error('Error fetching invia affida', error)
            setInviaAffida(prev => ({ ...prev, loading: false }))
        }
    }

    const fetchService = async (endpoint, setter, url = null) => {
        setter(prev => ({ ...prev, loading: true }))
        try {
            const requestUrl = url || `${BASE_URL}/api-v1/people/${endpoint}/list?contact_id=${id}`
            const res = await axios.get(requestUrl, { withCredentials: true })
            
            if (res.data && res.data.pagination) {
                 setter({
                     data: res.data.data,
                     pagination: res.data.pagination,
                     loading: false
                 })
            } else {
                setter({
                    data: res.data.data || res.data || [],
                    pagination: null,
                    loading: false
                })
            }
        } catch (error) {
            console.error(`Error fetching ${endpoint}`, error)
            setter(prev => ({ ...prev, loading: false }))
        }
    }

    const handleShowDetails = (type, item) => {
        setModalType(type)
        setSelectedItem(item)
        setShowModal(true)
    }

    const renderTable = (title, state, fetchFunction) => (
        <Col lg="12" className="mb-4">
            <Card className="card-block card-stretch card-height">
                <Card.Header className="d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">{title}</h4>
                    </div>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="table-responsive">
                        <Table className="table mb-0">
                            <thead className="table-color-heading">
                                <tr className="text-light">
                                    <th scope="col">ID</th>
                                    <th scope="col">Data Creazione</th>
                                    <th scope="col">Azioni</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.loading ? (
                                    <tr>
                                        <td colSpan="3" className="text-center">Caricamento...</td>
                                    </tr>
                                ) : state.data.length > 0 ? (
                                    state.data.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.id}</td>
                                            <td>{item.created_at ? `${new Date(item.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')} ${new Date(item.created_at).toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit'})}` : '-'}</td>
                                            <td>
                                                <Button 
                                                    size="sm" 
                                                    variant="info" 
                                                    onClick={() => handleShowDetails(title, item)}
                                                    className="d-flex align-items-center"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-eye mr-1" viewBox="0 0 16 16">
                                                      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
                                                      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/>
                                                    </svg>
                                                    View
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="text-center">Nessun dato disponibile</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    {state.pagination && (
                        <PaginationComponent
                            fetchList={fetchFunction}
                            paginationObject={state.pagination}
                            nPages={state.pagination.n_pages}
                            page={state.pagination.current_page}
                            numberOfItem={state.pagination.n_items}
                        />
                    )}
                </Card.Body>
            </Card>
        </Col>
    )

    return (
        <Container fluid>
            <Row>
                <Col lg="12">
                    <div className="d-flex flex-wrap align-items-center justify-content-between my-schedule mb-4">
                        <div className="d-flex align-items-center justify-content-between">
                            <h4 className="font-weight-bold">Storico Servizi: {contact ? `${contact.name} ${contact.surname}` : '...'}</h4>
                        </div>
                        <div className="create-workform">
                            <Button variant="primary" onClick={() => history.goBack()} className="d-flex align-items-center justify-content-between">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" fill="currentColor" className="mr-2">
                                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                </svg>
                                Indietro
                            </Button>
                        </div>
                    </div>
                </Col>
                {renderTable("Censimenti", censimenti, (url) => fetchService('censimento', setCensimenti, url))}
                {renderTable("Quota", quote, (url) => fetchService('quota', setQuote, url))}
                {renderTable("Criteri", criteri, (url) => fetchService('criteri', setCriteri, url))}
                {renderTable("Preventivi", preventivi, (url) => fetchService('preventivi', setPreventivi, url))}
                {/*
                // Privacy and Invia Affida lists are intentionally hidden;
                // the Privacy workflow is managed via the backend templates.
                {!servicesHidden && renderTable("Privacy", privacies, () => fetchPrivacies())}
                {!servicesHidden && renderTable("Invia Affida", inviaAffida, () => fetchInviaAffida())}
                */}
            </Row>
            
            <ServiceDetailsModal 
                show={showModal}
                onHide={() => setShowModal(false)}
                type={modalType}
                data={selectedItem}
            />
        </Container>
    )
}

export default ContactServiceHistory
